import type { ICta } from "../config";

export const ctaMock: ICta = {
  title: "Maximize your time.",
  subtitle: "Start using the most powerful AI YouTube summary tool now.",
  btnText: "Install on Chrome",
};
